/** Arrondit au `step` du mode et borne entre `min` et `max`. */
export function snapToStep(value: number, min: number, max: number, step: number): number {
  const snapped: number = min + Math.round((value - min) / step) * step;
  const decimals: number = (step.toString().split('.')[1] ?? '').length;
  return Math.min(max, Math.max(min, Number(snapped.toFixed(decimals))));
}

/** Projette une valeur sur l'axe [min, max], en %. */
export function valueToHeightPercent(value: number, min: number, max: number): number {
  return ((value - min) / (max - min)) * 100;
}

export function minOf(values: number[]): number | undefined {
  return values.length ? Math.min(...values) : undefined;
}

export function maxOf(values: number[]): number | undefined {
  return values.length ? Math.max(...values) : undefined;
}

export function avgOf(values: number[]): number | undefined {
  if (!values.length) return undefined;
  return Math.round(
    values.reduce((total: number, value: number) => total + value, 0) / values.length,
  );
}

export function maxValueLength({
  min,
  max,
  step,
}: {
  min: number;
  max: number;
  step: number;
}): number {
  const decimals: number = (step.toString().split('.')[1] ?? '').length;
  const decimalsLength: number = decimals ? decimals + 1 : 0;
  return Math.max(String(Math.trunc(min)).length, String(Math.trunc(max)).length) + decimalsLength;
}
